import React from "react";

import classnames from "classnames";
import EstimatedCosts from "ComparePlans/Components/EstimatedCosts";
import HeaderWithTooltip from "ComparePlans/Components/HeaderWithTooltip";
import MoreDetails from "ComparePlans/Components/MoreDetails";
import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import isIntuit from "Intuit/isIntuit";
import formatCurrency from "Utils/formatCurrency";

import { enrollmentForOverview, chooseCoverageRows } from "../Utils/chooseCoverage";
import Button from "Common/Button";
import InfoPopover from "Common/InfoPopover";
import PlanRecommendation from "Common/PlanRecommendation";
import { ContentRow } from "Common/Table";

import makeBem from "Utils/makeBem";

const bem = makeBem("MultipleMedicalPlans");

const pricingTable = (prices, contributions, familyInfo, plans) =>
  chooseCoverageRows(familyInfo, prices, contributions, enrollmentForOverview(prices, familyInfo), "medical").map((row) => (
    <ContentRow
      heading={row.label}
      key={row.rowId}
      className={classnames(bem("specificCostRow"))}
      cell={(_, i) => <>{formatCurrency(row.prices[i])}/mo</>}
      items={plans}
    />
  ));

const MultipleMedicalPlans = ({ prices, contributions, familyInfo, plans, onClick }) => (
  <>
    <tbody>
      <ContentRow
        cell={(_) => (
          <span>
            <strong>Your Cost</strong>
            <InfoPopover
              infoTitle="Payroll Contributions"
              infoText="This is the amount you pay each month, taken directly out of your paycheck."
              placement="top"
            />
          </span>
        )}
        heading={<strong>Person</strong>}
        className={classnames(bem("payrollContributonHeaderRow"))}
        items={plans}
      />
      {pricingTable(prices, contributions, familyInfo, plans)}

      <ContentRow
        heading="Recommended For"
        className="row-separator"
        cell={(plan) => <PlanRecommendation recommendation={plan.recommendation} />}
        items={plans}
      />

      <ContentRow
        heading={<HeaderWithTooltip text="Deductible" term="Deductible" level={isIntuit() ? 8 : 4} />}
        className="row-separator"
        cell={(p) => `${formatCurrency(p.deductible)}`}
        items={plans}
      />

      <ContentRow
        heading={<HeaderWithTooltip text="Maximum" term="Annual Out-of-Pocket Limit" level={isIntuit() ? 8 : 4} />}
        cell={(p) => `${formatCurrency(p.limit)}`}
        items={plans}
      />

      <ContentRow heading={<HeaderWithTooltip text="Plan Network" term="Plan Network" level={isIntuit() ? 8 : 4} />} cell={(p) => p.plan_type} items={plans} />

      <ContentRow
        heading={<HeaderWithTooltip text="Doctor Visits" term="Estimated Doctor Visit" level={isIntuit() ? 8 : 4} />}
        className="row-separator"
        cell={(plan) => formatCurrency(plan.estimated_costs.pcp_visit)}
        items={plans}
      />

      <ContentRow
        heading={<HeaderWithTooltip text="Prescription Drugs" term="Estimated Prescription Drugs" level={isIntuit() ? 8 : 4} />}
        cell={(plan) => `${formatCurrency(plan.estimated_costs.generic_drugs)} - ${formatCurrency(plan.estimated_costs.brand_drugs)}`}
        items={plans}
      />

      <ContentRow
        heading={<HeaderWithTooltip text="Hospitalization" term="Estimated Hospitalization" level={isIntuit() ? 8 : 4} />}
        cell={(plan) => formatCurrency(plan.estimated_costs.hospitalization)}
        items={plans}
      />

      <ContentRow heading="Summary of Benefits & Coverage" className="row-separator sbc" cell={(plan) => <SBCLinkCell plan={plan} />} items={plans} />

      <ContentRow
        cell={(p) => (
          <Button
            text="Enroll or Decline"
            color="blue"
            size="medium"
            fullWidth
            className={classnames(bem("selectPlanButton"))}
            data-keyboard="true"
            onClick={(_) => onClick(p.id)}
          />
        )}
        items={plans}
      />
    </tbody>
    <EstimatedCosts plans={plans} />
    <tbody>
      <ContentRow
        cell={(p) => (
          <Button
            text="Enroll or Decline"
            size="medium"
            fullWidth
            className={classnames(bem("selectPlanButton"))}
            data-keyboard="true"
            onClick={(_) => onClick(p.id)}
          />
        )}
        items={plans}
      />
    </tbody>
    <MoreDetails plans={plans} />
  </>
);

export default MultipleMedicalPlans;
